function removeItemOnce(arr, value) {
  var index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}


function filterProducts(e, item, section) {
  let currentFilterItems = JSON.parse(localStorage.getItem(section));
  
  if (currentFilterItems != null && currentFilterItems != '[]') {
    if (currentFilterItems.includes(item) == false){
      currentFilterItems.push(item)
      e.classList.add('active')
      localStorage.setItem(section, JSON.stringify(currentFilterItems));
    } else if (currentFilterItems.includes(item) == true){
      currentFilterItems = removeItemOnce(currentFilterItems, item)
      e.classList.remove('active')
      localStorage.setItem(section, JSON.stringify(currentFilterItems));
    }
  } else {
      currentFilterItems = [item]
      e.classList.add('active')
      localStorage.setItem(section, JSON.stringify(currentFilterItems));
  }
}

function clearFilter(e, section) {
  localStorage.removeItem(section);

  var allElems = e.parentElement.querySelectorAll('li')
  for (let i = 0; i < allElems.length; i++) {
    const element = allElems[i];
    element.classList.remove('active')
  }
}

function removeFilter(term) {
  let currentcolors = JSON.parse(localStorage.getItem('filter-color'));
  let currentranges = JSON.parse(localStorage.getItem('filter-range'));
  let currentcategories = JSON.parse(localStorage.getItem('filter-category'));
  let currentstyles = JSON.parse(localStorage.getItem('filter-style'));
  
  if (currentcolors != null && currentcolors.includes(term)) {
    currentcolors = removeItemOnce(currentcolors, term)
    localStorage.setItem('filter-color', JSON.stringify(currentcolors));
  }
  if (currentranges != null && currentranges.includes(term)) {
    currentranges = removeItemOnce(currentranges, term)
    localStorage.setItem('filter-range', JSON.stringify(currentranges));
  }
  if (currentcategories != null && currentcategories.includes(term)) {
    currentcategories = removeItemOnce(currentcategories, term)
    localStorage.setItem('filter-category', JSON.stringify(currentcategories));
  }
  if (currentstyles != null && currentstyles.includes(term)) {
    currentstyles = removeItemOnce(currentstyles, term)
    localStorage.setItem('filter-style', JSON.stringify(currentstyles));
  }

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  
  var terms = params.q.split(' OR ')

  let filterItems = ''

  for (let index = 0; index < terms.length; index++) {
    const element = terms[index];
    if (element != term) {
      if (filterItems != ''){
        filterItems = filterItems + "+OR+" + element
      } else {
        filterItems = element
      }
    }
  }

  window.location.href = '/search?q=' + filterItems
}


function fireFilter() {
  let currentcolors = JSON.parse(localStorage.getItem('filter-color'));
  let currentranges = JSON.parse(localStorage.getItem('filter-range'));
  let currentcategories = JSON.parse(localStorage.getItem('filter-category'));
  let currentstyles = JSON.parse(localStorage.getItem('filter-style'));

  let filterItems = ''


  if (currentcolors != null)  {
    currentcolors.forEach(element => {
      if (filterItems != ''){
        filterItems = filterItems + "+OR+" + element
      } else {
        filterItems = element
      }
    });
  }

  if (currentranges != null) {
    currentranges.forEach(element => {
      if (filterItems != ''){
        filterItems = filterItems + "+OR+" + element
      } else {
        filterItems = element
      }
    });
  }

  if (currentcategories != null) {
    currentcategories.forEach(element => {
      if (filterItems != ''){
        filterItems = filterItems + "+OR+" + element
      } else {
        filterItems = element
      }
    });
  }
  if (currentstyles != null) {
    currentstyles.forEach(element => {
      if (filterItems != ''){
        filterItems = filterItems + "+OR+" + element
      } else {
        filterItems = element
      }
    });
  }
  window.location.href = '/search?q=' + filterItems
}
